<template>
  <span
    v-observe-visibility="{
      callback: visibilityChanged,
      once: true,
      throttle: 100,
      intersection: {
        rootMargin: '200px 0px'
      }
    }"
    class="line-height-sm page-no-break-inside"
  >
    <span v-if="business_case_loaded && (isVisible || !lazy_load)" @click="openImgPopup">
      <div v-if="modal_business_case == true">
        <div v-if="business_case_mode === 'popup'">
          <b-icon
            class="mr-1"
            icon="briefcase"
            scale="1"
            :style="`color: ${selected_report.main_color};`"
          />
          <a
            class="business-case-link cursor mr-3 mb-2 mt-2"
            :style="main_color"
            @click="showBusinessCase()"
          >
            <!-- <b-icon icon="briefcase" class="mr-1"/>  -->
            {{ lang != 'ENG' ? business_case_info?.title : business_case_info?.title_e }}
          </a>

          <div
            v-if="opened_modal_id.includes('bc_' + business_case_id)"
            class="hj-modal-example-lg bg-white rounded shadow pb-3"
          >
            <div
              class="hj-modal-header fw-500 d-flex align-items-center justify-content-between px-3"
            >
              <div>
                <b-icon
                  class="mr-1"
                  icon="briefcase"
                  scale="1"
                  :style="`color: ${selected_report.main_color};`"
                />
                <!-- <b-badge variant="border-light" class="mr-2">Case.</b-badge>  -->
                {{ lang != 'ENG' ? business_case_info?.title : business_case_info?.title_e }}
              </div>
              <div style="min-width: 74px" align="right">
                <b-button
                  variant="icon-light"
                  class="py-0 px-2 mr-1"
                  @click="low_height = !low_height"
                >
                  <fa :icon="low_height == true ? 'expand' : 'compress-alt'" /> </b-button
                ><b-button variant="icon-light" class="py-0 px-2" @click="closeBusinessCase()">
                  <fa icon="times" />
                </b-button>
              </div>
            </div>

            <div class="hj-modal-body p-3" :class="{ 'bc-low-height': low_height }">
              <template v-if="lang != 'ENG'">
                <HtmlText
                  class="bc-simple-content pb-4"
                  :content="business_case_info?.description"
                />
                <div
                  v-if="
                    business_case_info?.business_case_id != '' &&
                    business_case_info?.files?.length > 0
                  "
                  class="f-95 gray-800 mb-45"
                >
                  첨부파일 :
                  <span v-for="item in business_case_info?.files" :key="item.id" class="mr-3">
                    <a :href="$store.state.static_host + item.file_path" target="_blank">{{
                      item.file_name
                    }}</a>
                  </span>
                </div>
              </template>

              <template v-else>
                <div
                  v-image-modal
                  class="bc-simple-content pb-4"
                  v-html="sanitizedDescriptionE"
                ></div>
                <div
                  v-if="
                    business_case_info?.business_case_id != '' &&
                    business_case_info?.files_e?.length > 0
                  "
                  class="f-95 gray-800 mb-45"
                >
                  Attatched File :
                  <span v-for="item in business_case_info?.files_e" :key="item.id" class="mr-3">
                    <a :href="$store.state.static_host + item.file_path" target="_blank">{{
                      item.file_name
                    }}</a>
                  </span>
                </div>
              </template>
            </div>
          </div>
        </div>

        <div v-if="business_case_mode === 'accordion'" class="no-page-break-inside">
          <div
            class="fw-500 d-flex align-items-center cursor mt-3 pb-2"
            :style="main_color"
            @click="hideBusinessCaseFromAccordion"
          >
            <b-icon
              class="mr-1"
              icon="briefcase"
              scale="1"
              :style="`color: ${selected_report.main_color};`"
            />
            {{ lang != 'ENG' ? business_case_info?.title : business_case_info?.title_e }}
          </div>
          <div class="border rounded">
            <div class="px-3 py-3" :class="{ 'bc-low-height': low_height }">
              <template v-if="lang !== 'ENG'">
                <HtmlText
                  class="bc-simple-content pb-4 f-95 gray-800"
                  :content="business_case_info?.description"
                />
                <div
                  v-if="
                    business_case_info?.business_case_id != '' &&
                    business_case_info?.files?.length > 0
                  "
                  class="f-95 gray-800 mb-45"
                >
                  첨부파일 :
                  <span v-for="item in business_case_info?.files" :key="item.id" class="mr-3">
                    <a :href="$store.state.static_host + item.file_path" target="_blank">{{
                      item.file_name
                    }}</a>
                  </span>
                </div>
              </template>

              <template v-else>
                <HtmlText
                  class="bc-simple-content pb-4"
                  :content="business_case_info?.description_e"
                />
                <div
                  v-if="
                    business_case_info?.business_case_id != '' &&
                    business_case_info?.files_e?.length > 0
                  "
                  class="f-95 gray-800 mb-45"
                >
                  Attatched File :
                  <span v-for="item in business_case_info?.files_e" :key="item.id" class="mr-3">
                    <a :href="$store.state.static_host + item.file_path" target="_blank">{{
                      item.file_name
                    }}</a>
                  </span>
                </div>
              </template>
            </div>
          </div>
        </div>

        <div v-if="business_case_mode === 'newtab'">
          <!-- :style="background-color: rgb(216, 253, 222);" -->
          <div class="fw-500 d-flex align-items-center justify-content-between">
            <a
              class="business-case-link cursor mr-3 mb-2 mt-2"
              :style="main_color"
              @click="
                redirectToSamplePage(
                  business_case_info?.description,
                  business_case_info?.description_e
                )
              "
            >
              <!-- <b-icon icon="briefcase" class="mr-1"/>  -->
              <!-- <b-badge class="mr-2">Case.</b-badge>  -->
              <b-icon
                class="mr-1"
                icon="briefcase"
                scale="1"
                :style="`color: ${selected_report.main_color};`"
              />
              {{ lang != 'ENG' ? business_case_info?.title : business_case_info?.title_e }}
            </a>
          </div>
        </div>
      </div>

      <div v-else>
        <a
          v-if="show_title == true"
          class="business-case-link cursor mr-3 mb-2 mt-2"
          :style="main_color"
        >
          <b-icon icon="briefcase" class="mr-1" />
          {{ lang != 'ENG' ? business_case_info?.title : business_case_info?.title_e }}
        </a>

        <template v-if="lang != 'ENG'">
          <HtmlText class="bc-simple-content pb-4" :content="business_case_info?.description" />
          <div
            v-if="
              business_case_info?.business_case_id != '' && business_case_info?.files?.length > 0
            "
            class="f-95 gray-800 mb-45"
          >
            첨부파일 :
            <span v-for="item in business_case_info?.files" :key="item.id" class="mr-3">
              <a :href="$store.state.static_host + item.file_path" target="_blank">{{
                item.file_name
              }}</a>
            </span>
          </div>
        </template>

        <template v-else>
          <HtmlText class="bc-simple-content pb-4" :content="description_e" />
          <div
            v-if="
              business_case_info?.business_case_id != '' && business_case_info?.files_e?.length > 0
            "
            class="f-95 gray-800 mb-45"
          >
            Attatched File :
            <span v-for="item in business_case_info?.files_e" :key="item.id" class="mr-3">
              <a :href="$store.state.static_host + item.file_path" target="_blank">{{
                item.file_name
              }}</a>
            </span>
          </div>
        </template>
      </div>
    </span>

    <span v-else-if="!business_case_loaded">
      <b-skeleton width="10%" />
    </span>

    <!-- Visibility placeholder when not visible -->
    <div
      v-else-if="lazy_load && !isVisible"
      class="business-case-placeholder d-flex align-items-center"
    >
      <b-icon
        class="mr-1"
        icon="briefcase"
        scale="1"
        :style="`color: ${selected_report.main_color};`"
      />
      <span class="text-muted">{{ lang != 'ENG' ? 'Loading case...' : 'Loading case...' }}</span>
    </div>

    <b-modal
      :id="`modal-center_${business_case_idx}`"
      centered
      :title="'비즈니스 사례 예시'"
      hide-footer
      size="lg"
    >
      <div class="border rounded">
        <div
          class="fw-500 d-flex align-items-center cursor px-4 pt-3 pb-2"
          :style="main_color"
          @click="hideBusinessCaseFromAccordion"
        >
          <b-icon
            class="mr-1"
            icon="briefcase"
            scale="1"
            :style="`color: ${selected_report.main_color};`"
          />
          {{ lang != 'ENG' ? business_case_info?.title : business_case_info?.title_e }}
        </div>

        <div class="px-4 pb-4" :class="{ 'bc-low-height': low_height }">
          <template v-if="lang !== 'ENG'">
            <HtmlText
              class="bc-simple-content pb-4 f-95 gray-800"
              :content="business_case_info?.description"
            />
            <div
              v-if="
                business_case_info?.business_case_id != '' && business_case_info?.files?.length > 0
              "
              class="f-95 gray-800 mb-45"
            >
              첨부파일 :
              <span v-for="item in business_case_info?.files" :key="item.id" class="mr-3">
                <a :href="$store.state.static_host + item.file_path" target="_blank">{{
                  item.file_name
                }}</a>
              </span>
            </div>
          </template>

          <template v-else>
            <HtmlText class="bc-simple-content pb-4" :content="business_case_info?.description_e" />
            <div
              v-if="
                business_case_info?.business_case_id != '' &&
                business_case_info?.files_e?.length > 0
              "
              class="f-95 gray-800 mb-45"
            >
              Attatched File :
              <span v-for="item in business_case_info?.files_e" :key="item.id" class="mr-3">
                <a :href="$store.state.static_host + item.file_path" target="_blank">{{
                  item.file_name
                }}</a>
              </span>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
  </span>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import { generateRandomString } from '@/components/util';
import { sanitizeHtml } from '@/components/sanitize.js';
import HtmlText from '../../story_board/viewer_component/HtmlText.vue';

export default {
  name: 'BusinessCase',
  components: {
    HtmlText
  },
  props: {
    business_case_id: { type: [String, Number], default: '' },
    modal_business_case: { type: Boolean, default: true },
    show_title: { type: Boolean, default: true },
    business_case_mode: { type: String, default: 'popup' },
    lazy_load: { type: Boolean, default: true }
  },
  data() {
    return {
      low_height: false,
      business_case_idx: this.generateRandomString(6),
      isVisible: false
    };
  },
  computed: {
    ...mapGetters('report_list', ['selected_report']),
    ...mapState(['backend_host']),
    ...mapState('report_list', ['report_code', 'lang', 'view_mode']),
    ...mapState('gri2021_modal_open_status', ['opened_modal_id']), //open된 bc 확인,
    ...mapState('business_cases', ['business_case_list', 'business_case_loaded']),
    business_case_info() {
      const idx = this.business_case_list.findIndex(item => {
        return item.business_case_id == this.business_case_id;
      });
      if (idx > -1) {
        return this.business_case_list[idx];
      } else {
        return {
          files: []
        };
      }
    },
    main_color() {
      return `color:` + this.selected_report.main_color;
    },
    sanitizedDescriptionE() {
      return sanitizeHtml(this.business_case_info?.description_e);
    }
  },
  methods: {
    ...mapMutations('gri2021_modal_open_status', ['delete_opened_bc_id']),
    generateRandomString,

    visibilityChanged(isVisible) {
      if (isVisible && !this.isVisible) {
        this.isVisible = true;
      }
    },
    openImgPopup(e) {
      const img = e.target;
      if (img.tagName === 'IMG') {
        this.$EventBus.$emit('image-modal', img.getAttribute('src'), true);
      }
    },
    showBusinessCase() {
      this.$bvModal.show(`modal-center_${this.business_case_idx}`);
    },
    closeBusinessCase() {
      this.delete_opened_bc_id(this.business_case_id);
    },
    hideBusinessCaseFromAccordion(event) {
      const titleDiv = event.currentTarget;
      const contentDiv = titleDiv.nextElementSibling;
      if (contentDiv) {
        contentDiv.classList.toggle('hide');
      }
    },
    redirectToSamplePage() {
      if (this.lang !== 'ENG') {
        const newTab = window.open('', '_blank');
        if (newTab) {
          newTab.location.href =
            this.$store.state.frontend_host + `/form_gallery?type=bsc&id=${this.business_case_id}`;
        }
      } else {
        const newTab = window.open('', '_blank');
        if (newTab) {
          newTab.location.href =
            this.$store.state.frontend_host +
            `/form_gallery?type=bsc&id=${this.business_case_id}&lang=ENG`;
        }
      }
    }
  }
};
</script>

<style scoped>
.bc-simple-content ::v-deep img {
  cursor: pointer;
}

.business-case-placeholder {
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
  margin: 5px 0;
}

/* low_height 토글 시 모달 본문 높이 — viewport 50%에서 헤더 50px 제외,
 * 가로모드 폰처럼 짧은 viewport(viewport-h ~360px)에서는 200px 플로어로 너무
 * 좁아지지 않게 보호 (#663) */
.bc-low-height {
  height: calc(50vh - 50px) !important;
  min-height: 200px;
}
</style>
